import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { Habirint } from '@df/interfaces';
import { MAIN_DOMAIN } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class HabirintService {
    constructor(private http: HttpClient) {}

    createHabirint(habirint: Habirint): Observable<boolean> {
        return this.http.post<boolean>(`${MAIN_DOMAIN}/api/main_analytics/habirint_create/`, habirint);
    }

    updateHabirint(habirintData: Habirint): Observable<boolean> {
        return this.http.patch<boolean>(
            `${MAIN_DOMAIN}/api/main_analytics/habirint_update/${habirintData.id}`,
            habirintData
        );
    }
}
